import React from 'react';
import Style from './Projects.module.css';
import { Row, Col, Button, Card, Carousel } from 'react-bootstrap';

function ProjectsPage() {
  return (
    <div className={Style.body}>
      <Row>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630683508/Screenshot_2021-09-03_at_16.36.43_vkhpxn.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630683499/Screenshot_2021-09-03_at_16.37.03_fittpb.png'
                    alt='Second slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630683503/Screenshot_2021-09-03_at_16.37.51_ailyhg.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>Cars45.com</Card.Title>
                <Card.Text className={Style.subtitle}>
                  This is the largest automobile platform in Nigeria where users
                  can buy,sell and swap cars.The application has varieties of
                  features within the auto space and the user experience is
                  superb
                </Card.Text>
                <Button
                  href='https://buy.cars45.com/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630682507/Screenshot_2021-09-03_at_16.18.46_emoevs.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630682507/Screenshot_2021-09-03_at_16.19.05_h7pugg.png'
                    alt='Second slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1630682507/Screenshot_2021-09-03_at_16.18.57_ut7gqr.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>DOLLA</Card.Title>
                <Card.Text className={Style.subtitle}>
                  DOLLA is an virtual banking application that allows users to
                  signup and perform core banking transactions right from the
                  comfort of their homes.This services the need of every bank
                  user
                </Card.Text>
                <Button
                  href='https://dollaapp-ad52d.web.app/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612178997/cheese1_s5gj43.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612179510/cheese2_bbcgnu.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612179909/cheese3_dun0ik.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>CHEESE</Card.Title>
                <Card.Text className={Style.subtitle}>
                  The cheese application is a payment system interface where
                  registered users can make payment and bank transfer of
                  funds.This is just a proposed frontend with no backend
                  functionality
                </Card.Text>
                <Button
                  href='https://cheese-b86d1.web.app/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612180276/playstix1_tuif8x.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612180682/playtix2_macpxy.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612180807/playstix3_xgm9qx.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>PLAYSTIX</Card.Title>
                <Card.Text className={Style.subtitle}>
                  Playstix is a movie game Api frontend demo project that allows
                  users to preview diffrent movies and games .The project uses
                  the free movie and game APIs to generate data and firebase
                  authentication
                </Card.Text>
                <Button
                  href='https://playstix-1605d.web.app/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181259/ks3_zp47lm.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181259/ks1_wzfhv4.png'
                    alt='Second slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181259/ks2_hk4r8o.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>KASSANDAH</Card.Title>
                <Card.Text className={Style.subtitle}>
                  This is a request approval system where a user raises a
                  request and it passes through series of approval channel until
                  the final approval and the request is closed.Users can track
                  request status
                </Card.Text>
                <Button
                  href='https://kassandah.gigmobility.com/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181926/tima1_dqz5xc.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181925/tima2_mo6czr.png'
                    alt='Second Slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612181928/tima3_iftjed.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>TIMA</Card.Title>
                <Card.Text className={Style.subtitle}>
                  This is a logistic platform where users can order for bike
                  delivery services.This application is built with node ,express
                  and mongo db.There is also an admin end to the application
                  where configs are made
                </Card.Text>
                <Button
                  href='http://logistics.tima.ng/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612183289/rgb1_w3etjq.png'
                    alt='First slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>RGB GAME</Card.Title>
                <Card.Text className={Style.subtitle}>
                  A simple color gaming application to practice dom manipulation
                  and css tricks.The application is purely vanilla javascript
                  and css with no external library used in the app
                </Card.Text>
                <Button
                  href='https://falola0021.github.io/colorgameApp/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612183949/ussd1_qoukmj.png'
                    alt='First slide'
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612183949/ussd2_bmxvpj.png'
                    alt='Third slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>USSD APP</Card.Title>
                <Card.Text className={Style.subtitle}>
                  A simple node express application where users can perform
                  crude operations on ussd codes.This is to facilitate
                  transactions via ussd code. All popular ussd codes are saved
                  in the database
                </Card.Text>
                <Button
                  href='http://ussdcode-app.herokuapp.com/'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
        <Col sm={3}>
          <div className={Style.card}>
            <Card>
              <Carousel indicators={false} controls={false}>
                <Carousel.Item>
                  <img
                    className={Style.image}
                    src='https://res.cloudinary.com/adedayo/image/upload/v1612184922/figma_musy7w.png'
                    alt='First slide'
                  />
                </Carousel.Item>
              </Carousel>
              <Card.Body>
                <Card.Title className={Style.title}>FIGMA PROTOTYPE</Card.Title>
                <Card.Text className={Style.subtitle}>
                  This is one of my prototyping projects.It's a simple mobile
                  application design with prototyping linking.The layout is
                  built with FIGMA and you can preview the css source code in
                  the preview section
                </Card.Text>
                <Button
                  href='https://www.figma.com/proto/dkGQqFXQ0ttNpLfP0t3EFp/MY-TRAFFIC-APP?scaling=scale-down&node-id=5%3A31'
                  className={Style.btn}
                  target='_blank'>
                  visit app
                </Button>
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProjectsPage;
